import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconWashout$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconWashout extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '09247a6f955cc8c0d3479fafe57a53b1875e6f58', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '768914703209f38ef76a653eb03d569638fafee3', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '3f3e6599c6295345873ba5808f7317d6b65b50b9', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M18 4.33a.33.33 0 0 0-.33-.33h-4.34a.33.33 0 0 0-.23.56l1.66 1.66L11 10 7.83 6.81A2 2 0 1 0 6 8a1.9 1.9 0 0 0 .75-.15L9.94 11l-.65.65c-1.36 1.34-2 2-2 3.52A3.65 3.65 0 0 0 11 18.75a3.64 3.64 0 0 0 3.76-3.5c0-1.54-.71-2.24-2.13-3.64l-.57-.61 3.76-3.76 1.62 1.66a.33.33 0 0 0 .56-.23zm-4.74 10.92a2.14 2.14 0 0 1-2.26 2 2.18 2.18 0 0 1-2.25-2c0-.85.27-1.16 1.59-2.45l.66-.65.58.57c1.42 1.33 1.68 1.65 1.68 2.53", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-washout", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-washout"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-washout":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconWashout$1);
            }
            break;
    } });
}

const CosmosIconWashout = CosmosIconWashout$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconWashout, defineCustomElement };
